import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterAction,
  CharacterSheetInterface,
  CreatureInstance,
  SummonInstance,
} from "@dndModels";

import CharacterEffectsPDF from "@dndComponents/character/pdf/CharacterEffectsPDF";

interface Props { 
  character?: Character;
  char_int: CharacterSheetInterface | CreatureInstance | SummonInstance;
  action: CharacterAction,
}

export default function CharacterActionPDF({
  character,
  char_int,
  action,
}: Props) {
  const [fetched, setFetched] = useState(false);
  
  const heightFinder: any = React.createRef();

   
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });
  
  const load = () => {
    setFetched(true);
    setTimeout(() => {
      if (heightFinder && heightFinder.current instanceof HTMLElement) {
        action.pdf_height = heightFinder.current.height;
      }
    }, 1000);
  }

  const name = action.name;
  const fontSize = name.length < 15 ? "10px" : "6px";
  return (
    <Grid ref={heightFinder} className="padded">
      <Grid container spacing={0} direction="row" style={{ backgroundColor: "lightgray" }}>
        <Grid
          className="centered"
          style={{ fontSize }}
          size={{
            xs: 3
          }}>
          { name }
        </Grid>
        <Grid
          size={{
            xs: 9
          }}>
          { action.action &&
            <CharacterEffectsPDF 
              character={character}
              char_int={char_int}
              obj={action.action}
              level={action.level}
              casting_time={action.casting_time}
              // log_it={action.name.includes("Agathys")}
              show_extra_effects={true} 
              action={action}
            />
          }
        </Grid>
      </Grid>
    </Grid>
  );
}
